export const AZUREB2CSERVICE_INIT = 'AZUREB2CSERVICE_INIT';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';
